import CommonModal from "./CommonModal";
import delIcon from "../assets/del.svg";
import { Spinner } from "react-bootstrap";

export default function DeleteModal({ show, onClose, onDelete, deleting }) {
  return (
    <CommonModal show={show} onClose={onClose}>
      <div className="modal-card-body p-3">
        <div className="modal-card-content">
          <div className="modal-iconbx mb-2">
            <img src={delIcon} alt="Delete" />
          </div>
          <div className="message-title mb-3">Confirm Deletion</div>
          <div className="message-text mb-3">
            Once deleted, this cannot be restored. Please proceed with caution.
          </div>
        </div>
        <div className="card-footer-box">
          <button onClick={onClose} className="btn-grey ms-auto me-3">
            Close
          </button>
          <button onClick={onDelete} className="btn-black">
           {deleting ? <Spinner size="sm"/> : "Delete"}
          </button>
        </div>
      </div>
    </CommonModal>
  );
}
